import { render } from "./Page32.vue?vue&type=template&id=4045db81"
import script from "./Page32.vue?vue&type=script&lang=js"
export * from "./Page32.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__